import React, { useState, createContext, useContext } from 'react';
interface User {
  id: string;
  name: string;
  email: string;
  merchantId: string;
  merchantName: string;
}
interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  login: (user: User) => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const login = (userData: User) => {
    setIsAuthenticated(true);
    setUser({
      ...userData,
      merchantName: 'Gadgets Zone'
    });
  };
  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };
  return <AuthContext.Provider value={{
    isAuthenticated,
    user,
    login,
    logout
  }} data-id="element-853">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};